import {InputAdornment, TextField} from "@mui/material";
import React from "react";
import {generateKey} from "../../utils";
import * as PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import SearchIcon from '@mui/icons-material/Search';

const CompTextFieldNew = (props) => {
    const key = generateKey('text-field');
    const { label, isLabelShrink, error, errorAlreadyTranslated = false, value = "", id, isSearch = false, ...componentProps } = props;

    const { t } = useTranslation('translation');
    
    const errorMessage = error && !errorAlreadyTranslated ? t("errors." + error) : error;
    const input = value === 0 || value ? value : '';
    return (
        <div className={`comp-text-field-container-new ${props.className ? 'container-' + props.className : ''}`}>
            <TextField
                id={key}
                size='small'
                slotProps={{
                    inputLabel: {
                      shrink: Boolean(isLabelShrink),
                    },
                    ...(isSearch && {input: {
                        endAdornment: (
                            <InputAdornment position="end">
                                <SearchIcon color={componentProps.disabled ? "disabled" : "action"} />
                            </InputAdornment>
                        ),
                    }}
                    )}}
                label={label}
                value={input}
                error={Boolean(error)}
                helperText={errorMessage}
                onClick={e => console.log(e)}
                variant="outlined"
                {...componentProps}
                sx={{'& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: '#404CE2',
                    },
                    ...( !componentProps.disabled && {
                        '&:hover fieldset': {
                            borderColor: '#007FFF',
                        },
                    }),
                    '&.Mui-focused fieldset': {
                        borderColor: '#0066cc', 
                        borderWidth: 2,
                    }
                }}}
            />
        </div>
    );
}

CompTextFieldNew.propTypes = {
    label: PropTypes.string,
    error: PropTypes.string,
    errorAlreadyTranslated: PropTypes.bool,
    value: PropTypes.any,
    id: PropTypes.string,
    className: PropTypes.string,
};

export { CompTextFieldNew };